/**
 * navigateRef — allows programmatic navigation from outside the React tree
 * (e.g. Keycloak event callbacks, Redux middleware).
 *
 * Usage inside a component rendered under the Router:
 *   const navigate = useNavigate();
 *   useEffect(() => { navigateRef.current = navigate; }, [navigate]);
 *
 * Usage outside the component tree:
 *   navigateRef.current?.('/login');
 */
export const navigateRef = { current: null };
